var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{attrs:{"bgColor":'transparent'}},[_c('CloseBack',{attrs:{"xColor":_vm.xColor}}),_c('TitleWrapper',{attrs:{"typecolor":_vm.xColor}},[_c('StyledTitle',[_vm._v("Thank You For Signing Up!")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }